<template>
  <v-row>
    <v-col cols="12">
      <v-autocomplete
        :value="value.auditStatuses"
        :label="$t('label.info.auditStatus')"
        :items="autocompletion.auditStatuses"
        multiple
        clearable
        hide-details
        @input="updateFilter('auditStatuses', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "UsageDataHostFilters",

  props: {
    value: { required: true, type: Object },
    hosts: { type: Array, default: () => [] },
  },

  computed: {
    autocompletion() {
      const auditStatuses = new Set();

      for (const item of this.hosts) {
        if (item.audit_status) {
          auditStatuses.add(item.audit_status);
        }
      }

      return {
        auditStatuses: Array.from(auditStatuses).sort(),
      };
    },
  },

  methods: {
    updateFilter(key, value) {
      this.$emit("input", { ...this.value, [key]: value || [] });
    },
  },
};
</script>
